import { createSelector } from 'reselect'
import { State } from 'index'

const shopSelector = (state: State) => state.shop

export const getCard = createSelector([shopSelector], (state) => state.card)
export const getShopContact = createSelector([shopSelector], (state) => state.contact)
export const getShopName = createSelector([shopSelector], (state) => state.name)
export const getShopResponsiblePerson = createSelector([shopSelector], (state) => state.responsible_person)
export const getStripeAccountId = createSelector([shopSelector], (state) => state.stripe_account_id)
export const getStripeCustomerId = createSelector([shopSelector], (state) => state.stripe_customer_id)
export const getStripePaymentMethodId = createSelector([shopSelector], (state) => state.stripe_payment_method_id)
export const getShopId = createSelector([shopSelector], (state) => state.shop_id)
